import React, { useEffect, useState, useRef } from "react";
import NextImage from 'next/image';
import Link from "next/link";
import IMAGES from '@/public/assets/img';
import enIN from '@/locales/home/enIN';
import esMX from '@/locales/home/esMX';
import enUS from "@/locales/home/enUS";
import { useRouter } from "next/router";
import TestimonialSlider from "@/component/shared/testimonialSlider";
import Head from "next/head";
import { getMetadata } from "@/component/shared/getMetaData";
import HomeSliderSwiper from "@/component/shared/homeSliderSwiper";
import AccordianFaq from "@/component/shared/accordianfaq";
import { pushCleverTapEvent } from "@/component/shared/pushCleverTapEvent";
import { WEB_URL } from "@/config/endpoints";
import ScrollTraking from "@/component/shared/scrollTracking";

export default function Home() {
  const [showVideoPopup, setShowVideoPopup] = useState(false);
  const videoRef = useRef(null);
  const router = useRouter();
  const { locale } = router;
  const t = (locale === 'es-mx' && esMX) || (locale === 'en-us' && enUS) || (locale === 'en-in' && enIN);
  const metadata = getMetadata(t);
  const sectionRef = useRef(null);
  const HeadingTag = locale === "en-in" ? "h1" : "h2";

  const scrollToSection = () => {
    if (sectionRef.current) {
      const headerOffset = 80; // Define the offset in pixels
      const elementPosition = sectionRef.current.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  };

  const [mWidth, setMWidth] = useState(0);

  const handleWindowResize = () => {
    setMWidth(window.innerWidth);
  }

  useEffect(() => {
    handleWindowResize();
    window.addEventListener('resize', handleWindowResize);
    if (locale === 'en-in') {
      pushCleverTapEvent("Visit_HomePage", { "PageName": 'HomePage' });
    }
    // unsubscribe from the event on component unmount
    return () => window.removeEventListener('resize', handleWindowResize);

  }, []);

  const playVideo = () => {
    setShowVideoPopup(true)
    playVideoOnClick()


  };
  const playVideoOnClick = () => {
    if (videoRef.current && videoRef.current.paused) {
      videoRef.current.play();
    }
  };
  const handlePause = () => {
    setShowVideoPopup(false)
    if (videoRef.current && !videoRef.current.paused) {
      videoRef.current.pause();
    }
  }
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Credlix- Your Global Supply Chain Financing Partner",
    url: "https://www.credlix.com/",
    logo: "https://www.credlix.com/_next/image?url=%2Fassets%2Fimg%2Fcredlix-logo.png&w=128&q=75",
    sameAs: [
      "https://www.facebook.com/credlix/",
      "https://twitter.com/_credlix",
      "https://www.linkedin.com/company/credlix/",
    ],
  };
  const trackMeeting = () => {
    if (locale === 'en-in') {
      pushCleverTapEvent("Free_Buyer_Report", { "PageName": 'HomePage' });
    };
  }

  return (
    <main>

      <Head>
        <title>{metadata.title}</title>
        <meta name="description" content={metadata.description} />
        <meta name="keywords" content={metadata.keywords} />
        <link rel="icon" href={metadata.icon} />
        <meta property="og:title" content={metadata.openGraph.title} />
        <meta property="og:description" content={metadata.openGraph.description} />
        <meta property="og:image" content={metadata.openGraph.images} />
        <meta property="og:url" content={metadata.openGraph.url} />
        <link rel="canonical" href={metadata.alternates.canonical} />
        {t.indiaBanner ?
          <>
            {/* <link rel="preload" as="image" href={IMAGES.HomeNew.yellowRoadMb.src} />
            <link rel="preload" as="image" href={IMAGES.HomeNew.yellowRoad.src} />
            <link rel="preload" as="image" href={IMAGES.HomeNew.yellowBg.src} />
            <link rel="preload" as="image" href={IMAGES.HomeNew.yellowBgMb.src} /> */}
            <link rel="preload" as="image" href={IMAGES.HomeNew.blueBg.src} fetchPriority="high" />
            {/* <link rel="preload" as="image" href={IMAGES.HomeNew.blueBgMb.src} /> */}
            <link rel="preload" as="image" href={IMAGES.HomeNew.blueSea.src} fetchPriority="high" />
            {/* <link rel="preload" as="image" href={IMAGES.HomeNew.blueSeaMb.src} /> */}
          </> :
          <link rel="preload" as="image" href={IMAGES.HOMEIMG.mexicoHomeNew.src} />
        }
        {locale === 'en-in' && (
          <script
            defer
            async
            key="structured-data"
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
          />
        )}
      </Head>
      {locale === 'en-in' && <ScrollTraking />}

      {/* Mexico and US content */}
      {/* top banner starts */}
      {!t.indiaBanner &&
        <section className={`relative pt-[76px] md:pt-[65px] sm:pt-[54px] max-h-[90vh] min-h-[600px] h-[90vh] sm:max-h-[600px]`}
        // style={{ backgroundImage: mWidth < 768 ? `url(${IMAGES.HOMEIMG.mexicoHomeMobile.src})` : `url(${IMAGES.HOMEIMG.mexicoHomeNew.src})` }}
        >
          <NextImage src={IMAGES.HOMEIMG.mexicoHomeNew} priority={true} fetchPriority="high" width={1600} height={500} alt={t.BANNER.h1} className="absolute inset-0 z-0 sm:hidden w-full h-full" />
          <NextImage src={IMAGES.HOMEIMG.mexicoHomeMobile} priority={true} fetchPriority="high" width={700} height={883} alt={t.BANNER.h1} className="absolute inset-0 z-0 hidden sm:block w-full h-full" />

          <div className='container relative z-[1] h-full px-3 sm:before:bg-[rgba(255,255,255,0.7)] sm:before:absolute before:inset-0 sm:px-2'>
            <div className='flex z-[10] relative flex-wrap items-center h-full'>
              <div className='w-[50%] xm:w-1/2 md:pr-4 sm:w-full'>
                <h1 className='font-medium mb-1 text-heading1 sm:text-xxl xm:text-xxl text-brand'>{t.BANNER.h1}</h1>
                <p className='text-lg sm:text-base'>{t.BANNER.para}</p>
                <div className="flex mt-5">
                  {locale === 'en-us' && <>
                    <Link href={WEB_URL + `/export-factoring`} rel="noopener noreferrer" className="bg-gradient-to-r from-brand to-[#0363C4] border-[#072F5F] border-r-transparent shadow-md text-white text-sm sm:text-xs px-5 pl-10 sm:px-2 font-bold sm:font-medium rounded-s-[5px] h-[50px] flex items-center relative z-[2] transition-all duration-300 ease-in-out group group-hover:from-[#0363C4] group-hover:to-[#022B5C]"
                      onClick={
                        () => {
                          window.gtag('event', 'crossBorderTrade', {
                            'event_category': 'Cross Border Trade',
                            'event_label': 'Cross Border Trade'
                          });
                        }
                      }
                    >
                      <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" width="24" height="24" className="transition-transform duration-200 transform group-hover:translate-x-[-20px] sm:group-hover:translate-x-[-3px] sm:w-[14px] sm:h-[14px]">
                        <path fill="none" d="M0 0h24v24H0z"></path><path d="M7.82843 10.9999H20V12.9999H7.82843L13.1924 18.3638L11.7782 19.778L4 11.9999L11.7782 4.22168L13.1924 5.63589L7.82843 10.9999Z"></path></svg>
                      <span className="ml-1">  {t.BANNER.btn1}</span>
                    </Link>

                    <Link href={WEB_URL + `/partner-program`} rel="noopener noreferrer" className="bg-[#FECC2F] border-[1px] border-[#E3A003] border-l-transparent shadow-md text-brand group text-sm px-5 sm:text-xs pr-10 sm:px-2 font-bold sm:font-medium rounded-[5px] rounded-l-[0] h-[50px] flex items-center relative z-[2]"
                      onClick={
                        () => {
                          window.gtag('event', 'partnerProgram', {
                            'event_category': 'Partner Program',
                            'event_label': 'Partner Program'
                          });
                        }
                      }
                    >
                      <span className="mr-1">{t.BANNER.btn2}</span>
                      <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="brand" width="24" height="24" className="transition-transform duration-200 transform group-hover:translate-x-[20px] sm:group-hover:translate-x-[3px] sm:w-[14px] sm:h-[14px]"><path fill="none" d="M0 0h24v24H0z">
                      </path><path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"></path></svg>

                    </Link> </>}
                  {locale === 'es-mx' &&
                    <Link href={WEB_URL + `/india-mexico-connect`} rel="noopener noreferrer" className="bg-[#FECC2F] border-[1px] border-[#E3A003] shadow-md text-brand group text-sm px-5 sm:text-xs pr-10 sm:px-2 font-bold sm:font-medium rounded-[5px] h-[50px] flex items-center relative z-[2]"
                      onClick={
                        () => {
                          window.gtag('event', 'IndiaMexicoConnect', {
                            'event_category': 'India Mexico Connect',
                            'event_label': 'Financia tus importaciones desde India​'
                          });
                        }
                      }
                    >
                      <span className="mr-1">{t.BANNER.btn3}</span>
                      <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="brand" width="24" height="24" className="transition-transform duration-200 transform group-hover:translate-x-[20px] sm:group-hover:translate-x-[3px] sm:w-[14px] sm:h-[14px]"><path fill="none" d="M0 0h24v24H0z">
                      </path><path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"></path></svg>

                    </Link>}
                </div>
              </div>

            </div>
          </div>
        </section>
      }
      {t.indiaBanner &&
        <section className="relative pt-[76px] md:pt-[65px] lg:h-[78vh] max-h-[80vh] min-h-[560px] h-[80vh] sm:max-h-[600px]">
          <div className="absolute left-[50%] xl:pt-2 top-[145px] sm:top-[155px] z-10 translate-x-[-50%] w-full">
            <p className="text-white xl:text-[50px] xl:leading-[60px] lg:text-heading3 md:text-textxl sm:text-xl sm:max-w-[80%] sm:mx-auto sm:whitespace-break-spaces	 font-semibold text-center whitespace-pre	drop-shadow-md">{t.HomeNewData.banner.mainHeading}</p>
          </div>

          <div className="flex items-center h-full">
            <Link onClick={
              () => {
                window.gtag('event', 'domesticFinance', {
                  'event_category': 'Domestic finance',
                  'event_label': 'Domestic Financing'
                });
                pushCleverTapEvent("Domestic_Financing_Tab", { "PageName": 'HomePage', 'userProperties': 'financing_interest_type' });
              }
            } href={WEB_URL + `/invoice-discounting-for-smes`} rel="noopener noreferrer" className="flex h-full w-[50%] items-center relative overflow-hidden group">
              {mWidth > 768 ?
                <div className="absolute top-0 left-0 h-full w-[calc(100%+150px)] translate-x-[-150px] transition-transform duration-[1400ms] ease-in-out group-hover:translate-x-[0px]">
                  <NextImage width={640} fetchpriority="high" alt="Yellow Road" height={548} className="h-full w-full object-cover object-bottom" src={IMAGES.HomeNew.yellowRoad} />
                </div>
                :
                <NextImage priority={true} alt="Yellow Road mobile" className="absolute sm:block hidden w-full h-full object-cover right-0 left-0 top-0 z-[1] bottom-0" width={231} height={524} fetchpriority="high" src={IMAGES.HomeNew.yellowRoadMb} />}
              {mWidth > 768 ?
                <NextImage priority={true} alt="Yellow bg" className="absolute sm:hidden w-full h-full object-cover right-0 left-0 top-0 z-[1] bottom-0" width={1366} height={1322} fetchpriority="high" src={IMAGES.HomeNew.yellowBg} /> :
                <NextImage width={683} fetchpriority="high" height={661} alt="Yellow bg Mobile" className="absolute sm:block hidden w-full h-full object-cover top-0 right-0 left-0 bottom-0 z-[1]" src={IMAGES.HomeNew.yellowBgMb} />}





              <div className="bg-gradient-to-r from-[#022B5C] to-[#0363C4] shadow-md text-white text-sm sm:text-xs px-5 pl-10 sm:px-2 font-bold sm:font-medium rounded-s-[5px] h-[50px] ml-auto flex items-center xl:mt-[-90px] lg:mt-[-50px] mt-[-70px] sm:mt-[40px] relative z-[2] transition-all duration-300 ease-in-out group-hover:from-[#0363C4] group-hover:to-[#022B5C]">
                <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" width="24" height="24" className="transition-transform duration-200 transform group-hover:translate-x-[-20px] sm:group-hover:translate-x-[-3px] sm:w-[14px] sm:h-[14px]">
                  <path fill="none" d="M0 0h24v24H0z"></path><path d="M7.82843 10.9999H20V12.9999H7.82843L13.1924 18.3638L11.7782 19.778L4 11.9999L11.7782 4.22168L13.1924 5.63589L7.82843 10.9999Z"></path></svg>
                <span className="ml-1 text-base sm:text-xs">  {t.HomeNewData.banner.domesticCta} </span>
              </div>
              {mWidth > 768 ?
                <NextImage width={500} height={300} className="absolute xl:bottom-[100px] z-[2] lg:bottom-[60px] md:bottom-[70px] sm:bottom-[65px] translate-x-[160%] w-[45%] sm:w-[70%] sm:translate-x-0 sm:group-hover:translate-x-0 sm:right-[-30px] h-auto transition-all duration-[1400ms] group-hover:translate-x-[145%]" src={IMAGES.HomeNew.truckImgNew} alt="Truck" /> :
                <NextImage width={180} height={84} className="absolute xl:bottom-[100px] z-[2] lg:bottom-[50px] md:bottom-[70px] sm:bottom-[65px] translate-x-[160%] w-[45%] sm:w-[70%] sm:translate-x-0 sm:group-hover:translate-x-0 sm:right-[-30px] h-auto transition-all duration-[1400ms] group-hover:translate-x-[145%]" src={IMAGES.HomeNew.truckMb} alt="Truck" />
              }

            </Link>

            <Link onClick={
              () => {
                window.gtag('event', 'Export Financing Tab', {
                  'event_category': 'Export financing',
                  'event_label': 'Export Financing Tab'
                });
                pushCleverTapEvent("Export_Factoring_Tab", { "PageName": 'HomePage', 'userProperties': 'financing_interest_type' });
              }
            } href={WEB_URL + `/export-factoring`} rel="noopener noreferrer" className="flex h-full w-[50%] items-center relative overflow-hidden group">


              {mWidth > 768 ?
                <div className="absolute top-0 left-0 h-full w-[calc(100%+150px)] translate-x-[0px] transition-transform duration-[1400ms] ease-in-out group-hover:translate-x-[-150px]">
                  <NextImage priority={true} className="h-full w-full object-cover object-bottom" width={1232} height={1055} fetchPriority="high" alt="Blue Sea" src={IMAGES.HomeNew.blueSea.src} />
                </div>
                :
                <NextImage priority={true} className="absolute sm:block hidden w-full h-full object-cover right-0 left-0 top-0 z-[1] bottom-0" width={231} height={524} alt="Blue Sea Mobile" fetchPriority="high" src={IMAGES.HomeNew.blueSeaMb.src} />}
              {mWidth > 768 ?
                <NextImage priority={true} className="absolute sm:hidden w-full h-full object-cover right-0 left-0 top-0 z-[1] bottom-0" width={1366} height={1322} fetchPriority="high" alt="Blue background" src={IMAGES.HomeNew.blueBg} /> :

                <NextImage priority={true} width={683} height={661} className="absolute sm:block hidden w-full h-full object-cover top-0 right-0 left-0 bottom-0 z-[1]" alt="Blue background mobile" src={IMAGES.HomeNew.blueBgMb} />}



              <div className="bg-[#FECC2F] shadow-md text-brand text-sm px-5 sm:text-xs pr-10 sm:px-2 font-bold sm:font-medium rounded-e-[5px] h-[50px] mr-auto flex items-center xl:mt-[-90px] lg:mt-[-50px] mt-[-70px] sm:mt-[40px] relative z-[2]"

              >
                <span className="mr-1 text-base sm:text-xs">  {t.HomeNewData.banner.exportCta} </span>
                <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="brand" width="24" height="24" className="transition-transform duration-200 transform group-hover:translate-x-[20px] sm:group-hover:translate-x-[3px] sm:w-[14px] sm:h-[14px]"><path fill="none" d="M0 0h24v24H0z">
                </path><path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"></path></svg>

              </div>

              {mWidth > 768 ?
                <NextImage width={500} height={300} className="absolute z-[2] xl:bottom-[100px] lg:bottom-[60px] md:bottom-[70px] sm:bottom-[65px] translate-x-[-40%] w-[45%] sm:w-[70%] sm:translate-x-0 sm:group-hover:translate-x-0 h-auto transition-all duration-[1400ms] group-hover:translate-x-[-25%]" src={IMAGES.HomeNew.shipImgNew} alt="ship" /> :
                <NextImage width={180} height={84} className="absolute z-[2] xl:bottom-[100px] lg:bottom-[50px] md:bottom-[70px] sm:bottom-[65px] translate-x-[-40%] w-[45%] sm:w-[70%] sm:translate-x-0 sm:group-hover:translate-x-0 h-auto transition-all duration-[1400ms] group-hover:translate-x-[-25%]" src={IMAGES.HomeNew.shipMb} alt="ship" />
              }
            </Link>
          </div>

        </section>}
      <div className="flex max-w-[800px] items-center mx-auto w-full relative flex-wrap sm:w-[90%] z-[11] mt-[-40px] bg-white shadow-md py-1 px-3 pl-[40px] sm:px-3 sm:rounded-[30px] rounded-[100px]">

        <div className="w-[60%] sm:w-full">
          {mWidth > 768 ? <>
            <p className="text-base2 sm:text-center font-regular mb-[5px] text-black">{t.CTASection.heading}</p>
            <p className="text-sm sm:text-center font-regular mb-[5px] text-secondary">{t.CTASection.paragraph}</p>
          </> : <>
            <p className="text-sm font-medium text-center text-black mb-0.5">{t.CTASection.heading}</p>
            <p className="text-sm text-center font-regular text-secondary">{t.CTASection.paragraphMobile}</p>
            <p className="text-sm text-center mt-1 text-black font-bold">{t.CTASection.para2Mobile}</p>
          </>}
        </div>

        <div className="w-[40%] sm:w-full">
          {t.CTASection.ctaLink ?

            <Link href={t.CTASection.ctaLink}
              onClick={() => {
                window.gtag('event', 'click on generate a term sheet tab', {
                  'event_category': 'Generate Termsheet',
                  'event_label': 'Generate Termsheet'
                });
                trackMeeting()
              }}
              className="bg-gradient-to-r sm:mx-auto w-[220px] leading-[40px] from-[#022B5C] to-[#0363C4] shadow-lg text-white text-base px-2 text-center font-bold rounded-[24px] sm:mt-xsp h-[40px] ml-auto block transition-all duration-300 hover:from-[#0363C4] hover:to-[#022B5C]">
              {mWidth > 768 ? t.CTASection.cta : t.CTASection.ctaMobile}
            </Link>
            :
            <button type="button" className="bg-gradient-to-r sm:mx-auto from-[#022B5C] to-[#0363C4] shadow-lg text-white text-base px-5 pl-10 font-bold rounded-[24px] h-[50px] sm:mt-4 ml-auto block transition-all duration-300 hover:from-[#0363C4] hover:to-[#022B5C]"
              onClick={(e) => {
                e.stopPropagation(); // Stops any propagation to the parent
                scrollToSection();
                window.gtag('event', 'bookMeetingES​', {
                  'event_category': 'Generate Termsheet',
                  'event_label': 'Generate Termsheet'
                });
                trackMeeting()
              }}
            >
              <span>{t.CTASection.cta}</span>
            </button>
          }

        </div>
      </div>
      {/* {CTA section ends} */}
      {/* logos section start */}
      {t.Logos &&
        <section className="pt-[80px] pb-[50px]">
          <div className="container px-3 sm:px-2">
            <div className="flex flex-wrap items-center justify-center text-center">
              {t.Logos.map((item, i) => (
                <div key={i} className="w-auto sm:mb-2 sm:w-1/3 sm:text-center py-1 px-3">
                  <NextImage
                    className="m-auto w-auto h-[40px] sm:w-full sm:h-auto"
                    loading="lazy"
                    src={item.image}
                    alt={item.name}
                    width={120}
                    height={50}
                  />
                  {/* {item.name} */}
                </div>
              ))}


            </div>
          </div>
        </section>
      }
      {/* {logos section ends} */}
      {/* Solutions Section Starts */}
      <section className="pb-20 pt-24 sm:pt-10 sm:pb-[70px]">
        <div className='container px-3 xm:px-2'>
          <HeadingTag className="text-xxxl font-normal text-center max-w-[80%] m-auto mb-3 sm:max-w-full sm:text-xl" dangerouslySetInnerHTML={{ __html: t.SolutionsSec.heading }} />
          <p className="m-auto text-base max-w-[850px] w-full text-center font-regular">{t.SolutionsSec.paragraph}</p>

          <div className="flex flex-wrap justify-between mx-auto max-w-[1100px] mt-[60px]">
            {t.SolutionsSec.solutions.map((item, i) => (
              <Link href={item.href} onClick={() => pushCleverTapEvent(item.eventName, { "PageName": 'HomePage', })} rel="noopener noreferrer" key={i} className={`w-1/${t.SolutionsSec.solutions.length} sm:w-full px-xsp group`}>
                <div className="sm:w-full mb-3 p-3 pb-6 sm:pb-3 shadow-lg rounded-[15px] border border-[#E6E6E6]">

                  <div className="rounded-[8px] flex items-center px-1 w-[55px] h-[55px]" style={{ background: `${item.color}` }}>
                    <NextImage
                      className="m-auto w-auto h-auto"
                      style={{ width: "auto", height: "auto" }}
                      loading="lazy"
                      width={30}
                      height={34}
                      src={item.src}
                      alt={item.heading}
                    />
                  </div>
                  <h2 className="mt-4 mb-3 text-lg font-semibold text-black">{item.heading}</h2>
                  <p className="text-sm font-regular mb-3 min-h-[100px] md:min-h-[auto] sm:min-h-[auto]">{item.paragraph}</p>
                  <div className="flex items-center text-base text-[#3c3c3c] font-medium transition duration-150 ease-in-out group-hover:text-[#1479FC]">
                    <span className="mr-1">{t.SolutionsSec.learnmoreCta}</span>
                    <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="brand" width="24" height="24" className="transition-transform duration-200 transform group-hover:translate-x-[20px] fill-current text-[#3c3c3c] group-hover:text-[#1479FC]">
                      <path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"></path></svg>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
      {/* Solutions Section Ends */}
      
      {/* Numbers Section Starts */}
      <section className="py-[80px] relative overflow-hidden sm:py-[70px] md:py-[80px] bg-fixed" style={{ backgroundImage: `url( ${mWidth > 768 ? t?.ConuterSec?.bannerImg?.src : t?.ConuterSec?.bannerImg?.src})`, backgroundSize: 'cover' }}>
        {t.ConuterSec.bannerMbImage &&
          <NextImage src={t.ConuterSec.bannerMbImage} loading="lazy" className="sm:block z-[0] absolute hidden inset-0 w-auto h-full max-w-none" width={650} height={650} alt="stats bg" />
        }
        <div className='container z-[1] relative px-3 lg:px-3 xm:px-2'>
          <h2 className="mb-1 font-semibold text-center text-white text-xxxl sm:text-lg">{t.ConuterSec.heading}</h2>
          <p className="text-center text-white text-base2 font-regular">{t.ConuterSec.paragraph}</p>

          <div className="flex justify-between flex-wrap w-[80%] sm:w-full mx-auto">
            {t.ConuterSec.counterList.map((item, i) => (
              <div key={i} className="w-[22%] sm:w-full py-5 px-3">
                <h3 className="text-heading4 text-white font-medium text-center mb-[5px] flex items-center justify-center"> {item.heading} <strong className="text-textxl ml-[5px]">{item.smalltext}</strong></h3>
                <p className="text-base font-medium text-center text-white">{item.paragraph}</p>

              </div>
            ))}

          </div>
        </div>
      </section>
      {/* Numbers Section Ends */}
      {/* getfinance cta section start */}
      <section className={`pt-24 sm:pt-16 pb-24 sm:pb-[70px] md:pb-[50px] relative overflow-hidden ${t.SubSolutionsSec.FooterIndiaForm ? '' : 'bg-[#FECD2F]'}`} style={t.SubSolutionsSec.FooterIndiaForm ? {
          backgroundImage: `url(${IMAGES.HomeNew.dottedBg.src})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }  : {}}>
        <div className={`container px-3 lg:px-3 xm:px-2 ${t.SubSolutionsSec.FooterIndiaForm ? 'max-w-[1100px]' : ''}`}>
        <div className={t.SubSolutionsSec.FooterIndiaForm ? '' : 'flex flex-wrap justify-between items-center'}>
            <div className={`${t.SubSolutionsSec.FooterIndiaForm ? 'text-center' : 'text-left w-[42%] sm:w-full'}`}>
              {t.SubSolutionsSec.heading &&
                <h2
                  className={`${t.SubSolutionsSec.FooterIndiaForm ? 'w-4/5 m-auto mt-5 text-heading5 sm:text-textxl font-normal text-black sm:mt-0 sm:text-center' :'w-full text-heading3 sm:text-3xl sm:text-center' }`}
                  dangerouslySetInnerHTML={{ __html: t.SubSolutionsSec.heading }}
                />
              }

              {t.SubSolutionsSec.headingIndia &&
                <h2
                  className="w-4/5 m-auto mt-5 text-xxxl sm:text-base mb-2 font-normal text-black sm:mt-0 sm:text-center"
                  dangerouslySetInnerHTML={{ __html: t.SubSolutionsSec.headingIndia }}
                />
              }

              {t.SubSolutionsSec.para1 &&
                <p className="text-xxl text-black font-regular mb-1 sm:text-center">{t.SubSolutionsSec.para1}</p>}
              {t.SubSolutionsSec.para2 &&
                <p className="text-base text-black font-regular my-5 sm:text-center sm:mb-5">{t.SubSolutionsSec.para2}</p>}
              {t.SubSolutionsSec.para3 &&
                <p className="text-base text-black border-[#E3A003] pt-3 border-t-[1px] font-medium mb-1 sm:text-center">{t.SubSolutionsSec.para3}</p>}
              {t.SubSolutionsSec.para4 &&
                <p className="text-base text-black font-regular mb-4 sm:text-center">{t.SubSolutionsSec.para4}</p>}
              {mWidth > 767 && t.SubSolutionsSec.ctaText ?
                <div className="relative">
                  <button type="button" className="bg-gradient-to-r from-[#022B5C] to-[#0363C4] shadow-lg text-white text-lg font-semibold h-[54px] md:w-[400px] md:px-2 px-6 rounded-[24px] group"
                    onClick={(e) => {
                      e.stopPropagation(); // Stops any propagation to the parent
                      scrollToSection();
                      window.gtag('event', 'bookMeetingHome', {
                        'event_category': 'Book a meeting',
                        'event_label': 'Book a Meeting'
                      });
                    }}
                  >
                    <span className="inline-block align-middle">{t.SubSolutionsSec.ctaText}</span>
                  </button>
                </div> : ''
              }

            </div>
            <div className={`sm:w-full sm:justify-between flex flex-wrap ${t.SubSolutionsSec.FooterIndiaForm ? 'w-auto' : 'w-[52%] sm:w-full'}`}>
              {t.SubSolutionsSec.subSolutions.map((item, i) => (
                item.href ? (
                  <Link href={item.href} rel="noopener noreferrer" key={i} className="w-[31%] mr-2 sm:mr-0  sm:w-[47%] py-5 px-3 rounded-[15px] border border-[#E6E6E6] group mb-3 bg-white">
                    <span className="min-h-[40px] block">
                      <NextImage loading="lazy" width={40} height={40} style={{ width: "auto", height: "auto" }} src={item.src} alt={item.heading} className="w-[40px] h-auto" />
                    </span>
                    <p className="mt-2 mb-0 text-base font-medium text-[#3C3C3C]">{item.heading}</p>
                  </Link>
                ) : (
                  <div key={i} className="w-[30%] mr-2 sm:mr-0 sm:w-[47%] py-5 px-3 rounded-[15px] border border-[#E6E6E6] group mb-3 bg-white">
                    <span className="min-h-[40px] mb-2 block">
                      <NextImage loading="lazy" width={40} height={40} style={{ width: "auto", height: "auto" }} src={item.src} alt={`solutions image ${i}`} className="w-[40px] h-auto" />
                    </span>
                    {item.heading &&
                      <p className="mt-2 mb-0 text-base font-medium text-[#3C3C3C]">{item.heading}</p>
                    }
                    {item.para &&
                      <p className="text-sm" dangerouslySetInnerHTML={{ __html: item.para }} />
                    }
                  </div>
                )


              ))}
              {/* {t.SubSolutionsSec.FooterIndiaForm &&
                <FormProvider>
                  {!showNextStep ?
                  // use homepage form here 
                    <ContactFormStep1 showStep1={showSteps} isHomepageForm={true} /> :
                    <ContactFormStep2 showPrevStep={showFirstStep} formType="GetInTouchNew" isHomepageForm={true} />
                  }
                </FormProvider>} */}
            </div>

            {mWidth < 767 && t.SubSolutionsSec.ctaText &&
              <div className="w-[85%] mt-5 mx-auto">
                <button type="button" className="bg-gradient-to-r from-[#022B5C] to-[#0363C4] shadow-lg text-white text-base px-5 pl-10 font-bold rounded-[24px] h-[50px] mx-auto block transition-all duration-300 hover:from-[#0363C4] hover:to-[#022B5C]"
                  onClick={(e) => {
                    e.stopPropagation(); // Stops any propagation to the parent
                    scrollToSection();
                    window.gtag('event', 'bookMeetingHome', {
                      'event_category': 'Book a meeting',
                      'event_label': 'Book a Meeting'
                    });
                  }}
                >
                  <span>  {t.SubSolutionsSec.ctaText} </span>
                </button>
              </div>
            }
            {t.SubSolutionsSec.FooterIndiaForm &&
               <div className="w-fit sm:w-full m-auto">
                <button aria-label="Get Financed CTA" className="bg-gradient-to-r rounded-[5px] from-[#022B5C] to-[#0363C4] shadow-lg text-white text-base px-5 font-bold h-[50px] ml-auto sm:mx-auto block transition-all duration-300 hover:from-[#0363C4] hover:to-[#022B5C]" onClick={scrollToSection}>Get Financed Now</button>
              </div>}
          </div>
        </div>

      </section>
      {/* why choose credlix Section Ends */}
      {/* Capital Solution Section Starts */}
      {t.CapitalSolution &&
        <section className={`py-[125px] xl:pb-[200px] sm:py-[70px] md:py-[80px] relative sm:before:hidden before:right-0`}>

          {mWidth > 767 ?
            <div className={`bg-no-repeat bg-contain absolute z-[1] w-[45%] xl:top-[10%] lg:top-[22%] md:top-[25%] left-0 sm:hidden`}>
              <NextImage loading="lazy" onClick={playVideo} alt={t.CapitalSolutionSec.bannerAltText} width={665} height={580} className="w-full h-full cursor-pointer" src={t.CapitalSolutionSec.bannerImg} />
            </div> : ''
          }
          <div className='container px-3 lg:px-3 xm:px-2'>
            <div className="ml-auto w-[50%] sm:w-full">
              <h2 className="text-xxxl text-black font-normal sm:text-xl mb-2 sm:max-w-full sm:text-center md:max-w-full" dangerouslySetInnerHTML={{ __html: t.CapitalSolutionSec.heading }} />
              <p className="text-base2 text-secondary font-regular sm:max-w-full sm:text-base sm:text-center sm:mb-5 md:max-w-full">{t.CapitalSolutionSec.paragraph}</p>

              <div className="flex justify-between flex-wrap mt-[20px]">
                {t.CapitalSolutionSec.capitalSolutionList.map((item, i) => (
                  <div key={i} className="w-[31%] sm:w-[47%] p-2 sm:p-2 pb-4 shadow-md rounded-[15px] border border-[#E6E6E6] group mb-5 min-h-[140px] sm:min-h-[auto]" style={{ background: `${item.color}` }}>
                    <span className="mx-auto">
                      <NextImage loading="lazy" width={50} height={50} style={{ width: "auto", height: "auto" }} src={item.src} alt={item.alt} className="m-auto w-[50px] h-[50px]" />
                    </span>
                    <h2 className="text-black mt-3 text-base text-center mx-auto sm:max-w-full" dangerouslySetInnerHTML={{ __html: item.text }} />

                  </div>

                ))}
              </div>
              <div className="w-fit sm:w-full">
                <button aria-label="Get Financed CTA" className="bg-gradient-to-r rounded-[5px] from-[#022B5C] to-[#0363C4] shadow-lg text-white text-base px-5 font-bold h-[50px] ml-auto sm:mx-auto block transition-all duration-300 hover:from-[#0363C4] hover:to-[#022B5C]" onClick={scrollToSection}>{t.CapitalSolutionSec.ctaText}</button>
              </div>

              {/* <p className="text-base2 text-black font-regular mb-[5px] sm:text-center sm:mt-3">{t.CapitalSolutionSec.subHead}</p>
                <p className="mb-3 text-sm text-secondary font-regular sm:text-center">{t.CapitalSolutionSec.subParagraph}</p>
                <div onClick={scrollToSection} className="sm:mx-auto sm:w-[85%] sm:mt-5">
                  <button type="button" className="bg-gradient-to-r from-[#022B5C] to-[#0363C4] shadow-lg text-white text-base px-5 pl-10 font-bold rounded-[5px] h-[50px] transition-all duration-300 hover:from-[#0363C4] hover:to-[#022B5C] sm:w-full"
                    onClick={(e) => {
                      e.stopPropagation(); // Stops any propagation to the parent
                        scrollToSection();
                      window.gtag('event', 'bookMeetingHome', {
                        'event_category': 'Book a meeting',
                        'event_label': 'Book a Meeting'
                      });
                    }}>
                    <span>  {t.BookAMeeting} </span>
                  </button>
                </div> */}
            </div>
          </div>
        </section>
      }

      {showVideoPopup == true &&
        <div className="fixed z-[999] inset-0 bg-[rgba(0,0,0,0.8)]" onClick={handlePause}>

          <div className="absolute  max-w-[800px] left-0 right-0 top-[50%] translate-y-[-50%] bottom-0 m-auto w-[95%]">
            <button className="absolute right-[-2px] top-[-2px] z-[1000] w-[25px] h-[25px]" onClick={handlePause}>
              <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="white" d="M12.0007 10.5865L16.9504 5.63672L18.3646 7.05093L13.4149 12.0007L18.3646 16.9504L16.9504 18.3646L12.0007 13.4149L7.05093 18.3646L5.63672 16.9504L10.5865 12.0007L5.63672 7.05093L7.05093 5.63672L12.0007 10.5865Z"></path></svg>
            </button>
            <div className="pb-[56%] relative">
              <video ref={videoRef} controls autoPlay className="absolute top-0 left-0 right-0 object-cover rounded-t-lg aspect-video" poster={IMAGES.HOMEIMG.homeBanner.src} style={{ width: '100%' }}>
                <source src="https://cdnx3.moglix.com/videos/Credlix.mp4" />
              </video>
            </div>
          </div>

        </div>
      }
      {t.HowItWorks &&
        <section className="sm:py-[70px] py-[80px] relative">
          <div className='container px-3 lg:px-3 xm:px-2'>
            <h2 className="text-xxxl text-black font-semibold sm:text-xl mb-5 text-center">{t.HowItWorks.heading}</h2>
            <div className="border-[#C4C4C4] border-[1px] shadow-[0_0_20px_0_rgba(0,0,0,0.1)] p-5 rounded-[20px] mx-auto max-w-[1200px]">
              <div className="flex flex-wrap items-start">
                {t.HowItWorks.steps.map((item, i) => (
                  <div className="w-[33.33%] relative text-center  p-3 sm:pb-14 px-10 sm:w-full" key={i}>
                    <div>
                      <span className="w-4 h-4 mx-auto text-sm mb-2 leading-[25px] text-white rounded-[50%] text-center block bg-[#086AC9]">{item.id}</span>
                      <h3 className="text-base mb-2 font-medium">{item.name}</h3>
                      <p className="text-sm">{item.para}</p>
                    </div>
                    {i != 2 &&
                      <div className="absolute top-[50%] sm:text-center sm:top-auto right-[-10px] sm:bottom-1 sm:right-0 mx-auto sm:left-0">
                        <svg className="w-5 h-5 sm:hidden " xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M19.1642 12L12.9571 5.79291L11.5429 7.20712L16.3358 12L11.5429 16.7929L12.9571 18.2071L19.1642 12ZM13.5143 12L7.30722 5.79291L5.89301 7.20712L10.6859 12L5.89301 16.7929L7.30722 18.2071L13.5143 12Z"></path></svg>
                        <svg className="w-5 h-5 hidden mx-auto sm:block" xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 19.1642L18.2071 12.9571L16.7929 11.5429L12 16.3358L7.20712 11.5429L5.79291 12.9571L12 19.1642ZM12 13.5143L18.2071 7.30722L16.7929 5.89301L12 10.6859L7.20712 5.89301L5.79291 7.30722L12 13.5143Z"></path></svg>
                      </div>
                    }
                  </div>

                ))}
              </div>

            </div>
          </div>
        </section>
      }
      {/* Capital Solution Section Ends */}
      {/* Partners Section Starts */}
      <section className="pb-[125px] sm:pb-[40px] md:pb-[80px]">
        <div className='container px-3 lg:px-3 xm:px-2'>
          <h2 className="mb-3 font-normal text-center text-black text-xxxl">{t.Investers.heading}</h2>

          <div className="overflow-hidden whitespace-nowrap mt-[50px] sm:mt-5 mx-auto">
            <div className="flex marquee">
              <div className="flex">
                {t.Investers.investerslList.map((item, i) => (
                  <div key={i} className="mr-3 partner-logo sm:mb-5">
                    <NextImage
                      style={{ width: "auto", height: "auto" }}
                      width={180}
                      loading="lazy"
                      height={180}
                      src={item.src}
                      alt={item.alt}
                      className="w-auto max-h-[180px] sm:mx-auto"
                    />
                  </div>
                ))}

                {t.Investers.investerslList.map((item, i) => (
                  <div key={i + t.Investers.investerslList.length} className="mr-3 partner-logo sm:mb-5">
                    <NextImage
                      style={{ width: "auto", height: "auto" }}
                      width={180}
                      loading="lazy"
                      height={180}
                      src={item.src}
                      alt={item.alt}
                      className="w-auto max-h-[180px sm:mx-auto"
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>

        </div>
      </section>
      {/* Partners Section Ends */}
      {/* Flags & Map starts*/}
      <section className="pb-[125px] sm:pb-[70px] md:pb-[80px]">
        <div className="container px-3 lg:px-3 xm:px-2">
          <div className="flex flex-wrap mx-auto max-w-[1100px]">
            <div className="w-1/2 sm:w-full">
              <NextImage loading="lazy" src={IMAGES.HomeNew.worldMap} alt="World Map" className="w-[90%] h-auto sm:mb-5" width={525} height={280} />
            </div>
            <div className="w-1/2 sm:w-full">
              <h2 className="text-xxxl text-black mb-3  w-full sm:text-xl" dangerouslySetInnerHTML={{ __html: t.GlobalNetwork.heading }} />
              <p className="text-base text-secondary max-w-[600px] w-full font-regular">{t.GlobalNetwork.para}</p>
              <ul className="flex flex-wrap max-w-[500px] mt-10">
                {t.GlobalNetwork.flags.map((item, index) => (
                  <li key={index} className="mr-10 sm:w-[32%] sm:px-1 sm:mb-5 sm:mr-0 last:mr-0">
                    <NextImage loading="lazy" src={item.flag} alt={item.name + ' flag icon'} className="w-[44px] sm:w-[40px] h-auto mx-auto" width={44} height={44} />
                    <span className="block mt-1 text-base text-center">{item.name}</span>
                  </li>
                ))}

              </ul>
            </div>
          </div>

        </div>
      </section>
      {/* Flags & Map ends*/}
      {/* {t.WhyChooseCredlix &&
        <section className="pb-24 md:pb-20 sm:pb-10">
          <div className="sm:container md:container lg:container lg:px-3 md:px-3 sm:px-3">
            <h2 className="mb-6 font-bold text-center text-xxxl text-secondary">Why Choose Credlix?</h2>
            <div className="flex max-w-[1100px] w-full mx-auto flex-wrap mb-20">
              <div className="w-1/2 relative overflow-hidden px-10 py-24 sm:py-10 sm:px-10 sm:w-full">
                <NextImage src={IMAGES.SID.yellowBg} loading="lazy" alt="Expertise in Supply Chain Financing" className="absolute max-w-none w-auto h-full z-0 inset-0" />
                <div className="z-[1] relative">
                  <h3 className="mb-2  text-xl font-bold">Expertise in Supply Chain Financing</h3>
                  <p className="text-base2">As part of the Moglix Group, we leverage deep industry insights and a robust network.</p>
                </div>
              </div>
              <div className="w-1/2 relative overflow-hidden px-10 py-24 sm:px-10 sm:py-10 sm:w-full">
                <NextImage src={IMAGES.SID.blueBg} loading="lazy" alt="Global Reach" className="absolute max-w-none w-auto h-full z-0 inset-0" />
                <div className="z-[1] relative">
                  <h3 className="mb-2 text-xl font-bold text-white">Global Reach</h3>
                  <p className="text-white text-base2">With offices in India, USA, UAE, and Mexico, and partnerships in 90 countries, we support your global trade needs.</p>
                </div>
              </div>
            </div>
            <div className="flex flex-wrap max-w-[1100px] items-center mx-auto">
              <p className="w-[70%] sm:w-full text-xl sm:mb-4 sm:text-center"><strong>Apply Today</strong> to unlock the value of your invoices and propel your business growth with <strong>Credlix</strong>.</p>
              <div className="w-[30%] sm:w-full">
                <button aria-label="Get Financed CTA" className="bg-gradient-to-r rounded-[5px] from-[#022B5C] to-[#0363C4] shadow-lg text-white text-base px-5 font-bold h-[50px] ml-auto sm:mx-auto block transition-all duration-300 hover:from-[#0363C4] hover:to-[#022B5C]" onClick={scrollToSection}>Get Financed Now</button>
              </div>
            </div>

          </div>
        </section>
      } */}
      <section className="pt-20 pb-16 bg-[#EAF3FD] sm:pt-10 sm:pb-8">
        <div className="container px-3 lg:px-3 xm:px-2">
          <div className="w-full mx-auto items-center">

            <h2 className="font-normal text-xxl  mb-1 text-center">{t.Credibility.heading}</h2>
            <p className="text-base text-center mb-10">{t.Credibility.subHeading}</p>

            <div className="w-full">
              <ul className="flex justify-between flex-wrap">
                {t.Credibility.awards.map((item, index) => (
                  <li key={index} className="w-[16%] border-[#C4C4C4] border-[1px] rounded-[8px] md:w-[32%] sm:w-[49%] overflow-hidden mb-2">
                    <NextImage loading="lazy" src={item} alt="award Image" className="w-full h-auto mx-auto" width={250} height={100} />

                  </li>
                ))}

              </ul>
            </div>
          </div>

        </div>
      </section>
      {/* Testimonial Section Starts */}
      {t.Testimonial &&
        <section className={`${t.Customers.paragraph ? 'pb-[80px]' : 'pb-0'} pt-20 sm:pb-[30px] md:pb-[80px]`}>
          <div className="container px-3 lg:px-3 xm:px-2">
            <h2 className="mb-3 font-normal text-center text-black text-xxxl sm:text-xl">{t.Customers.heading}</h2>
            <p className="text-center text-base2 text-secondary font-regular">{t.Customers.paragraph}</p>
            <TestimonialSlider content={t.Customers.customersList} interval={3000} knowMoreCta={t.Customers.knowMoreCta} />
          </div>
        </section>
      }
      {/* Testimonial Section Ends */}
      {/* Download app start */}
      {/* {t.DownloadApp &&
        <DownloadApp />

      } */}
      {/* FAQ Section Starts */}
      <section className='bg-white sm:py-[70px] py-[80px] grid place-items-center'>
        <div className='container px-3 xm:px-2 '>
          <div>
            <h3 className='mb-6 font-bold text-xl max-w-[1100px] mx-auto text-secondary'>{t.FAQ.Faq_heading}</h3>
          </div>
          <div className="w-full text-left bg-white">
            <div className="mx-auto max-w-[1100px] sm:w-auto">
              <AccordianFaq faqData={t.FAQ.Home_Faq} />
            </div>
          </div>
        </div>
      </section>
      {/* FAQ Section Ends */}
      {/* Download app End */}
     {/* {t.blogShow &&
        <HomeSliderSwiper />
      }*/}
      
      <div ref={sectionRef}></div>

    </main>




  )
}

